import * as React from 'react';
import { LazyLoadComponentWrapper } from '@components/lazy-load/lazy-load-component-wrapper';
import { CardLoadingIndicator } from '../../../../components/new-card-loader';
import { ICardProps } from '@components/cards/card-wrapper';

const cardTitle = 'Your incidents';
const DashboardCard = React.lazy(() => import(/* webpackChunkName:"im-card" */'./index'));

type IIncidentManagementCardOwnProps = ICardProps;

export const NewCard = (props: IIncidentManagementCardOwnProps) => {
    return (
        <LazyLoadComponentWrapper
            fallback={<CardLoadingIndicator error={false} cardTitle={cardTitle} />}
            errorIndicator={<CardLoadingIndicator error={true} cardTitle={cardTitle} />}>
            <DashboardCard {...props} />
        </LazyLoadComponentWrapper>
    );
};
